module.exports = __webpack_public_path__ + "img/icon_system_terminal_calendar.1f0685cd.svg";